<div class="shared-modal position-relative">
    <div class="head d-flex align-items-center justify-content-between">
        <h4 class="title">Enter Pin Code</h4>
        <div class="crossbtn text-end" (click)="onNoClick()">
            <img class="align-top"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/close.svg'" alt="Close | Luminous" />
        </div>
    </div>
    <p class="mt-4">Enter a pincode to see product availability & delivery options.</p>
    <div class="text-center">
        <div class="mt-5">
            <form class="cst-form-group d-flex flex-row chooseLocationGroup " [formGroup]="pincodeForm"
                (ngSubmit)="updatePinCode()">
                <input type="text" class="cst-form-control me-3" maxlength="6" formControlName="pinCode"
                    placeholder="Enter Pincode" limitNumber
                    [limitNumberObj]="{limitPhoneNum:true,limitTo:6,formGroup:pincodeForm}" />
                <button type="submit" [disabled]="pincodeForm.invalid" class="grey-btn">Apply</button>
            </form>
        </div>
    </div>
</div>
